export default __webpack_public_path__ + "static/media/correspondent_color.0afcfe6e.svg";